import {
	SET_APP_STATE,
} from '../actions/AppActions';
import AppGlobals from '../../AppGlobals';
import _ from 'lodash';

export default function handleAppStateChange(appState) {
	return async (dispatch, getState) => {
		dispatch({
			type: SET_APP_STATE,
			appState, // 'active' || 'inactive' || 'background'
		});

		AppGlobals.audioPlayer.handleAppStateChange(appState);

	};
}
